import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"attic-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 2C12.0207 2.03098 14.7782 6.14442 17.998 8V18H6L5.99805 8C9.23165 6.13785 12 2 12 2Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10 14.8C10 13.6955 10.8954 12.8 12 12.8C13.1046 12.8 14 13.6955 14 14.8V18H10V14.8Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 14.8C10 13.6955 10.8954 12.8 12 12.8C13.1046 12.8 14 13.6955 14 14.8V18H10V14.8Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.99805 18L3.99805 18M4.99805 18L4.99805 21M4.99805 18L5.99805 18M19.998 18H18.998M18.998 18L18.998 21M18.998 18H17.998M11.998 21L11.998 18M11.998 18H17.998M11.998 18H5.99805M3.99805 8.5C4.67106 8.5 5.34408 8.37661 5.99805 8C9.23165 6.13785 11.9996 2 11.9996 2C11.9996 2 14.7661 6.13695 17.9981 7.99955C18.652 8.37642 19.325 8.5 19.998 8.5M17.998 18V8.5M5.99805 18V8.5M6.75 8H17.252","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Attic1 = Vue.extend<IconProps>({
  name: 'Attic1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'attic-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Attic1;
